import React from "react";
import { Link } from "react-router-dom";

import TrackIcon from '../../images/report_btn_illustrations/TrackIcon';
import { useTranslation } from "react-i18next";

export default function TrackingReportButton() {
  const {t} = useTranslation("review_activity");
  return (
    <Link to="/teacher/reports/type/tracking" className="trackingReportButton">
      <TrackIcon />
      <div className="trackingReportTextContainer">
        <span className="trackingReportText">
          {t("Go To The")}
        </span>
        <span className="reports-splash-block-header trackingReportSubText">
          {t("Tracking Report")}
        </span>
      </div>
    </Link>
  );
}